import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form.js';
import { Textarea } from '@/components/ui/textarea.js';
import clsx from 'clsx';
import { ComponentProps, ReactNode } from 'react';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

interface FormTextAreaProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  form: UseFormReturn<TFieldValues>;
  name: TName;
  label: string;
  labelEndContent?: ReactNode;
  textAreaProps?: ComponentProps<typeof Textarea> & { 'data-testid'?: string };
}

export function FormTextArea<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ form, name, label, labelEndContent, textAreaProps = {} }: FormTextAreaProps<TFieldValues, TName>) {
  const { className, required } = textAreaProps;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center justify-between gap-2">
            <FormLabel className="font-bold">
              {label}
              {required && '*'}
            </FormLabel>
            {labelEndContent}
          </div>
          <FormControl>
            <Textarea {...field} {...textAreaProps} className={clsx(className)} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
